export default "__VITE_ASSET__OK7xDtvy__"